import { useState } from 'react';
import { addRecentBrandSlug, getFavoriteBrandSlugs, getRecentBrandSlugs, toggleFavoriteBrandSlug } from '@/dom/brandPreferences';

export function useBrandPreferences() {
  const [recent, setRecent] = useState<string[]>(() => getRecentBrandSlugs());
  const [favorites, setFavorites] = useState<string[]>(() => getFavoriteBrandSlugs());

  function markRecent(slug: string) {
    addRecentBrandSlug(slug);
    setRecent(getRecentBrandSlugs());
  }

  function toggleFavorite(slug: string) {
    setFavorites(toggleFavoriteBrandSlug(slug));
  }

  return { recent, favorites, markRecent, toggleFavorite };
}
